// Focus lands on a RESULT the moment it appears (design-system §3.8: the
// primary record is inline, not a toast).
//
// WHY. The withdraw and archive dialogs close BECAUSE their request landed —
// the result is the mutation's own data, and the dialog unmounts in the
// render that shows it. `Modal` then restores focus to its opener, which is
// the Withdraw / Archive control in the state banner — and the refetch the
// hook's invalidation triggers removes that control a moment later (the row
// is archived now; there is nothing left to withdraw or archive). Focus fell
// to `<body>`: a keyboard user's next Tab started again from the top of the
// page, and a screen reader that had just announced the `role="status"`
// banner offered no way to reach the "Open version N" control inside it.
//
// This wrapper is where focus goes instead. Its ONLY content is the result
// banner: `tabIndex={-1}` makes it a programmatic focus target without
// adding a Tab stop, and the focus effect runs on mount — after the Modal's
// unmount cleanup in the same commit, so it is the last word on where focus
// is. The next Tab reaches the banner's own controls.

import { useEffect, useRef, type ReactNode } from "react";

export function ResultFocus({
  children,
  testId,
}: {
  children: ReactNode;
  testId?: string | undefined;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    ref.current?.focus();
  }, []);
  return (
    <div ref={ref} tabIndex={-1} className="cat-result-focus" data-testid={testId}>
      {children}
    </div>
  );
}
